var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bizs && _vm.bizs.length)?_c('div',[_c('div',{staticClass:"title-style"},[_vm._v("Nearby Restaurants")]),_c('BizList',{attrs:{"bizs":_vm.bizs,"loading":_vm.loading}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }